import activity from './activity.es.json';
import assets from './assets.es.json';
import auth from './auth.es.json';
import commissions from './commissions.es.json';
import common from './common.es.json';
import dashboard from './dashboard.es.json';
import payouts from './payouts.es.json';
import profile from './profile.es.json';
import rewards from './rewards.es.json';
import rewardsV3 from './rewardsV3.es.json';
import shareLink from './shareLink.es.json';
import stats from './stats.es.json';
import transactions from './transactions.es.json';

const es = {
  activity,
  assets,
  auth,
  commissions,
  common,
  dashboard,
  payouts,
  profile,
  rewards,
  rewardsV3,
  shareLink,
  stats,
  transactions,
};

export default es;
